import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MasterService } from 'src/app/shared/services/master.service';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { ConsultationLinkWithAbhaComponent } from '../../pro/consulatation/consulatation/consultation-link-with-abha/consultation-link-with-abha.component';

@Component({
  selector: 'app-immunization',
  templateUrl: './immunization.component.html',
  styleUrls: ['./immunization.component.css']
})
export class ImmunizationComponent implements OnInit {
  @Input() patientDetails:any

  immunizationList:any[] = [];
  isNDHMEnable: boolean = false;
  careContextHide: boolean = false;
  dtRender: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private regService: RegistrationService,
    private masterService: MasterService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private http: HttpClient,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.getFeaturePermission();
    this.loadData();
  }

     getFeaturePermission(){
    var featureList:any = JSON.parse(localStorage.getItem('featuresList'));
    if(localStorage.featuresList){
      for (let i = 0; i < featureList.length; i++) {
     
        if (featureList[i].feature_id.feature_name == "careContextHide") {
          if(featureList[i].patient){
            this.careContextHide = true;
          } else{
            this.careContextHide = false;
          }
        }

        if (featureList[i].feature_id.feature_name == "isNDHMEnable") {
          if(featureList[i].patient){
            this.isNDHMEnable = true;
          } else{
            this.isNDHMEnable = false;
          }
        }
    
  }
    }
   

  }

  loadData(){
   this.dtRender = false;
       this.immunizationList = [];
       this.regService.get(`poc-emr/jwt/doctor/poc/get-childcare-data/${this.patientDetails?.patient_interaction_id}`).subscribe({
         next: (res: any) => {
           if (res.status === 'OK') {
             if (res.data && Object.keys(res.data).length > 0) {
            this.immunizationList = [res.data];
           } else {
            this.immunizationList = [];
          }
           } else {
             this.toastr.error(res.message);
           }
           setTimeout(() => { this.dtRender = true; }, 100);
         },
         error: (err: HttpErrorResponse) => {
           this.toastr.error(err.message);
           setTimeout(() => { this.dtRender = true; }, 100);
         }
       }); 
  }

   openLinkwithAbhaConsultation(item) {
         const modalRef = this.modalService.open(ConsultationLinkWithAbhaComponent, { scrollable: true, size: 'xl' });
         modalRef.componentInstance.data = item;
          modalRef.componentInstance.hiType = 'ImmunizationRecord';
         modalRef.componentInstance.title = 'Link Care context with ABHA';
         modalRef.result.then(result => {
           // if (result == 'changes saved'){
             this.loadData();
            
           // } 
         }, (reason) => { });
   }

}
